import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Mail, ArrowLeft, CheckCircle2 } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/apiClient";
import { Input } from "../components/ui/input";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Could not send the reset link.");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16" data-testid="forgot-password-page">
      <span className="eyebrow">Researcher account</span>
      <h1 className="font-display font-extrabold text-4xl mt-3">Forgot password</h1>
      {sent ? (
        <div className="card-soft rounded-2xl p-6 sm:p-8 mt-8 text-center" data-testid="forgot-password-sent">
          <CheckCircle2 className="w-10 h-10 mx-auto text-[#2f7a3f]" />
          <p className="font-display font-bold text-lg mt-4">Check your inbox</p>
          <p className="text-muted-foreground mt-2 text-sm">If an account exists for <span className="font-semibold">{email.trim().toLowerCase()}</span>, we've emailed a link to reset your password. It expires in 60 minutes.</p>
          <Link to="/login" className="inline-flex items-center gap-2 font-semibold mt-6 underline underline-offset-4" style={{ color: "var(--gold)" }} data-testid="forgot-back-to-login">
            <ArrowLeft className="w-4 h-4" /> Back to sign in
          </Link>
        </div>
      ) : (
        <>
          <p className="text-muted-foreground mt-3">Enter the email on your account and we'll send you a secure link to set a new password.</p>
          <form onSubmit={submit} className="card-soft rounded-2xl p-6 sm:p-8 mt-8 space-y-5" data-testid="forgot-password-form">
            <div>
              <label className="text-sm font-bold" htmlFor="forgot-email">Email</label>
              <Input id="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 h-11 bg-white" data-testid="forgot-email" />
            </div>
            {error && <p role="alert" className="text-sm text-destructive" data-testid="forgot-error">{error}</p>}
            <button type="submit" disabled={busy} className="w-full h-12 rounded-xl btn-ink font-display font-bold inline-flex items-center justify-center gap-2 disabled:opacity-60" data-testid="forgot-submit">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Mail className="w-4 h-4" />} Send reset link
            </button>
          </form>
          <p className="text-sm text-muted-foreground mt-6 text-center">
            Remembered it? <Link to="/login" className="font-semibold underline underline-offset-4" style={{ color: "var(--gold)" }} data-testid="forgot-to-login">Back to sign in</Link>
          </p>
        </>
      )}
    </div>
  );
}
